import React, { RefObject } from "react";
import { Box, Paper, Skeleton, styled } from "@mui/material";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";
import MenuIcon from "@mui/icons-material/Menu";
import { ICreative } from "../../../interfaces/campaign";

interface IProps extends IWithClassName {
  bannerImage?: File | ICreative;
  bannerPreviewRef?: RefObject<HTMLImageElement>;
}

const Preview = ({ bannerImage, bannerPreviewRef, className }: IProps) => (
  <Box className={className}>
    <Box className="preview">
      <Box className="preview-info">
        <Box className="preview-header">
          <MenuIcon />
        </Box>

        <Box className="preview-other-post" component={Paper}>
          <Box sx={{ height: 20 }}>
            <Skeleton />
          </Box>
          <Box sx={{ height: 80 }}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </Box>
        </Box>

        {bannerImage && bannerPreviewRef && (
          <Box className="banner-cont">
            <PreviewMedia
              bannerImage={bannerImage}
              bannerPreviewRef={bannerPreviewRef}
            />
          </Box>
        )}

        <Box className="preview-other-post" component={Paper}>
          <Box sx={{ height: 20 }}>
            <Skeleton />
          </Box>
          <Box sx={{ height: 80 }}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

const PreviewMedia = ({ bannerImage, bannerPreviewRef }: IProps) => (
  <>
    {bannerImage?.type.includes("video") ? (
      <video controls>
        <source
          src={
            bannerImage.hasOwnProperty("url")
              ? (bannerImage as ICreative).url
              : URL.createObjectURL(bannerImage as File)
          }
          type="video/mp4"
        />
      </video>
    ) : (
      <img
        src={
          bannerImage?.hasOwnProperty("url")
            ? (bannerImage as ICreative).url
            : URL.createObjectURL(bannerImage as File)
        }
        alt="preview"
        ref={bannerPreviewRef}
      />
    )}
  </>
);

export default styled(Preview)(({ theme }: IWithThemeProps) => ({
  backgroundImage: "url(/assets/images/phone-background.svg)",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top",
  height: 430,
  backgroundColor: theme?.palette.background.default,
  ".preview": {
    backgroundColor: theme?.palette.background.default,
    width: 300,
    height: "calc(100% - 25px)",
    margin: theme?.spacing(3, "auto", 0),
    borderRadius: "15px 15px 0 0",
    ".preview-info": {
      height: "100%",
      borderRadius: "inherit",
      flexDirection: "column",
      overflow: "auto",
      display: "flex",
      gap: 10,
      "&::-webkit-scrollbar": {
        width: 2,
        display: "none",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "darkgrey",
        outline: "1px solid slategrey",
        width: 30,
      },
    },
    ".preview-header": {
      height: theme?.spacing(5),
      backgroundColor: theme?.palette.otherFeatures.previewHeader,
      display: "flex",
      justifyContent: "right",
      svg: {
        color: theme?.palette.otherFeatures.textColor,
        height: 40,
        width: 40,
        margin: theme?.spacing(0, 1),
      },
    },
  },
  ".preview-other-post": {
    margin: theme?.spacing(0, 0.5),
    padding: theme?.spacing(1),
  },
  ".banner-cont": {
    img: {
      width: "100%",
    },
    video: {
      width: "100%",
    },
  },
}));
